"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineEventService = void 0;
const v2_1 = require("./v2");
__exportStar(require("./v2/types"), exports);
function defineEventService() {
    return {
        id: 'event-service',
        create: () => {
            const eventServiceV1 = new v2_1.EventServiceV2Impl();
            return {
                '2.3.0': () => ({
                    featureService: eventServiceV1,
                }),
            };
        },
    };
}
exports.defineEventService = defineEventService;
//# sourceMappingURL=index.js.map